import { render, staticRenderFns } from "./uploadDocumentProject.vue?vue&type=template&id=4b25f942&scoped=true&"
import script from "./uploadDocumentProject.vue?vue&type=script&lang=js&"
export * from "./uploadDocumentProject.vue?vue&type=script&lang=js&"
import style0 from "./uploadDocumentProject.vue?vue&type=style&index=0&id=4b25f942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25f942",
  null
  
)

export default component.exports